import { z } from 'zod';

export const TrialTypeSchema = z.enum(['limited', 'full']);
export type TrialType = z.infer<typeof TrialTypeSchema>;